import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';  
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import LandingPage from './LandingPage';  
import LandingPageSME from './LandingPageSME';
import ProductPage from './component/ProductPage';
import LinePage from './component/LinePage';
import ContactPage from './component/ContactPage';
import PrivacyPage from './component/PrivacyPage';
import PrivacyPolicyPage from './component/PrivacyPolicyPage';
import BusinessPolicyPage from './component/BusinessPolicyPage';
import McpPage from './component/McpPage';
import SeoIntentPage from './component/SeoIntentPage';
import GuidePage from './component/GuidePage';

// 1. Create the ScrollToTop helper
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      requestAnimationFrame(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      });
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

const App = () => {
  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop /> 
      <div>
        <Routes>
          <Route exact path="/" element={<LandingPage />} />
          <Route path="/landingpageSME" element={<LandingPageSME />} />
          <Route path="/landingpage-sme" element={<LandingPageSME />} />
          
          <Route path="/product" element={<ProductPage />} />
          <Route path="/line" element={<LinePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/business-policy" element={<BusinessPolicyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/mcp" element={<McpPage />} />
          <Route path="/law" element={<Navigate to="/mcp" replace />} />
          <Route path="/guides/:slug" element={<GuidePage />} />
          <Route path="/:slug" element={<SeoIntentPage />} />
        </Routes>
      </div>
    </Router>
    </HelmetProvider>
  );
};

export default App;
